import PropTypes from "prop-types"
import { get } from "lodash"

import { Button } from "@mui/material"
import DisabledAction from "../disabled-action"

export default function ButtonAction({ onClick, disabled, children }) {
  const text = get(children, "props.children", children)

  if (disabled) {
    return <DisabledAction>{text}</DisabledAction>
  }
  return <Button className="resource-action" color="primary" onClick={onClick}>{text}</Button>
}

ButtonAction.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
